import { gql } from '@apollo/client';

export const CREATE_PRINT_PROVIDER = gql`
  mutation createProvider($body: Body!) {
    createProvider(body: $body)
      @rest(
        type: "Create Print Provider"
        path: "printprovider"
        method: "POST"
        bodyKey: "body"
      ) {
      printProviderId
      name
      isEnabled
      isOrgIdRequired
      description
      country
      language
      address
      phoneNumber
      email
      emailForOrders
      website
      omsType
      omsServiceUrl
      omsSecretKey
      deliveryOptions
      orderingSystems
      omsUsers
      documentPrintSettings {
        defaultPrintOption
        printOptions
        defaultPostProcessingOption
        postProcessingOptions
      }
      drawingPrintSettings {
        defaultFormatGroup
        formatGroups
        defaultPrintOption
        printOptions
        defaultPostProcessingOption
        postProcessingOptions
      }
    }
  }
`;
